import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { getMessageContent } from "./helper";

const Message = ({ is_sender, message, users }) => {

  const {email} = useSelector(state => state.auth);

  const getUserName = () => {
    const user = users.find(item => item.email === message.sender_email);
    return user?.email === email ? "You" : user?.name; 
  }

  return (
    <div className={`flex my-1.5 w-full rounded-md ${is_sender ? "justify-end" : "justify-start"}`}>
      <div
        className={`rounded-md max-w-[60%] py-1 px-2 cursor-pointer ${is_sender ? "bg-[#2F80ED] text-white" : "bg-[#F3F7FE]"}`}
      >
        <div className={`text-sm font-bold font-inter pr-4 capitalize ${is_sender ? "text-white" : "text-[#2F80ED]"}`}>{getUserName()}</div>
        {
          message.message_type === "text" && (
            <span className={`text-sm font-normal ${is_sender ? "text-white" : "text-[#1E293B]"}`}>{message?.message}</span>
          )
        }
        {message.message_type === "file" && (
          <div>{getMessageContent(message.message)}</div>
        )}

        <div className={`text-[11px] font-inter object-right-bottom pl-2 pt-1 ${is_sender ? "text-white": "text-[#868686]"}`}>
          <div className="flex flex-row items-center justify-end">
            {moment(message.createdAt).format("DD/MMM/yyyy - hh:mm a")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Message;
